import {AccountInfo} from "./AccountInfo";
import {BlackjackInfoForClient} from "./BlackjackInfoForClient";

export class ServerResponse {

    constructor(public accountInfo: AccountInfo,
                public blackjackInfoForClient: BlackjackInfoForClient,
                public sessionParam: number) {

    }
}



// WEBPACK FOOTER //
// ./src/app/api/serverResponseClasses/ServerResponse.ts